<module-container>
  <div class="title-container">
    <h2>Global Product</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
